<template>
  <div class="app-container">
    <el-form :model="queryParams" class="multipleSelectScroll" ref="queryForm" v-show="showSearch" label-width="85px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同编号" prop="contractNum">
            <el-input v-model="queryParams.contractNum" placeholder="请输入合同编号" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户编号" prop="customerNum">
            <el-input v-model="queryParams.customerNum" placeholder="请输入客户编号" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="签约客户" prop="customerName">
            <el-input v-model="queryParams.customerName" placeholder="请输入客户名称" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同状态" prop="contractStatusList">
            <el-select v-model="queryParams.contractStatusList" placeholder="请选择合同状态" clearable multiple style="width:100%">
              <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机编号" prop="businessNum">
            <el-input v-model="queryParams.businessNum" placeholder="请输入商机编号" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="商机" prop="businessName">
            <el-input v-model="queryParams.businessName" placeholder="请输入商机名称" @keyup.enter.native="getList" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同类型" prop="contractTypeList">
            <el-select v-model="queryParams.contractTypeList" placeholder="请选择合同类型" clearable multiple style="width:100%">
              <el-option v-for="dict in contractTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同构成" prop="productTypeList">
            <el-select v-model="queryParams.productTypeList" placeholder="请选择" clearable multiple style="width:100%">
              <el-option v-for="dict in productTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="回款日期" prop="actualFundDate">
            <el-date-picker v-model="queryParams.actualFundDate" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="签约日期" prop="signTime">
            <el-date-picker v-model="queryParams.signTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户性质" prop="customerNatureList">
            <el-select v-model="queryParams.customerNatureList" placeholder="请选择客户性质" clearable multiple style="width:100%">
              <el-option v-for="dict in natureOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户类型" prop="customerTypeList">
            <el-select v-model="queryParams.customerTypeList" placeholder="请选择客户类型" clearable multiple style="width:100%">
              <el-option v-for="dict in customerTypeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="项目区域" prop="area">
            <el-cascader v-model="queryParams.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
          </el-form-item>
        </el-col>
        <dept-user-select ref="deptUserSelectRef" :formParam="queryParams" :autoSelectUser="autoSelectUser"></dept-user-select>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-user" :disabled="multiple" @click="handleAssign">分配</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['crm:contract:export']" type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>
    <el-row class="totalCount">
      <div style="font-size: 14px; margin: 5px 0">
        <span style="margin-right: 40px">合同总额（元）：{{ amountFormat(otherData.totalContractAmount / 10000) }}万</span>
        <span style="margin-right: 40px">签约总额（元）：{{ amountFormat(otherData.totalSignContractAmount / 10000) }}万</span>
        <span style="margin-right: 40px">回款总额（元）：{{ amountFormat(otherData.totalFundedAmount / 10000) }}万</span>
        <span style="margin-right: 40px">已回款比例：{{otherData.fundRate}} %</span>
        <span style="margin-right: 40px">待回款总额（元）：{{amountFormat(otherData.toFundAmount / 10000)}}万</span>
        <span>周期回款（元）：{{amountFormat(otherData.totalPartFundedAmount / 10000)}}万</span>
      </div>
    </el-row>
    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="合同编号" min-width="145" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.contractNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="签约客户" min-width="150" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="商机" min-width="140" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link v-if="scope.row.businessId" type="primary" class="crm-link-wrap" :underline="false" @click="toBusinessDetail(scope.row)">{{scope.row.businessName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="客户编号" min-width="130" align="center" prop="customerNum"/>
      <el-table-column label="商机编号" min-width="130" align="center" prop="businessNum"/>
      <el-table-column label="合同类型" min-width="100" align="center" prop="contractTypeDesc"/>
      <el-table-column label="合同构成" min-width="150" align="center" prop="productTypeDesc" show-overflow-tooltip/>
      <el-table-column label="膜面积(㎡)" min-width="110" align="center" prop="membraneArea">
        <template slot-scope="scope">
          <span>{{ scope.row.membraneArea === null || scope.row.membraneArea === undefined ? '-' : scope.row.membraneArea }}</span>
        </template>
      </el-table-column>
      <el-table-column label="合同状态" min-width="100" align="center" prop="contractStatusDesc"/>
      <el-table-column label="总金额(元)" min-width="100" align="center" prop="contractAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.contractAmount / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="已开票金额(元)" min-width="120" align="center" prop="invoiceAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.invoiceAmount / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="回款总额(元)" min-width="100" align="center" prop="fundedAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.fundedAmount / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="回款进度" min-width="80" align="center" prop="fundProcess">
        <template slot-scope="scope">
          <span>{{ scope.row.fundProcess }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="待回款(元)" min-width="120" align="center" prop="toFundAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.toFundAmount / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人" min-width="100" align="center" prop="assignUserName"/>
      <el-table-column label="签约日期" min-width="100" align="center" prop="contractSignDate"/>
      <el-table-column label="周期回款(元)" min-width="100" align="center" prop="partFundAmount">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.partFundAmount / 10000) }}万</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text"  @click="handleFollow(scope.row)">跟进</el-button>
          <el-button type="text"  @click="handlePlan(scope.row)">计划</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <el-dialog
      title="选择导出金额单位"
      :visible.sync="exportDialogVisible"
      width="420px"
      append-to-body
    >
      <el-form label-width="90px">
        <el-form-item label="金额单位">
          <el-radio-group v-model="exportAmountUnit">
            <el-radio label="YUAN">元</el-radio>
            <el-radio label="TEN_THOUSAND">万元</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExport">导出</el-button>
      </span>
    </el-dialog>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <PlanAddDialog ref="planAddDialogRef" @success="getList"></PlanAddDialog>
    <FollowAddDialog ref="followAddDialogRef" @success="getList"></FollowAddDialog>
    <AddContractDialog ref="addContractDialogRef" @success="handleContractSuccess"></AddContractDialog>
  </div>
</template>

<script>
import {pageContract} from "@/api/crm/contract";
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import PlanAddDialog from "@/views/crm/plan/planAddDialog";
import FollowAddDialog from "@/views/crm/follow/followAddDialog";
import AddContractDialog from "@/views/crm/contract/addContractDialog";
import {listAllLevelArea} from '@/api/crm/area'
import {transferCascaderOptionsForProvince} from '@/utils'
import {mapState} from 'vuex'
import {amountFormat} from '@/utils/index'
import deptUserSelect from "@/views/crm/components/deptUserSelect";
import download from "@/plugins/download"

export default {
  name: "ContractManage",
  data() {
    return {
      amountFormat,
      autoSelectUser: true,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      statusOptions: [],
      contractTypeOptions: [],
      productTypeOptions: [],
      natureOptions: [],
      customerTypeOptions: [],
      areaOptions: [],
      // 总条数
      total: 0,
      dataList: [],
      exportDialogVisible: false,
      exportAmountUnit: 'TEN_THOUSAND',
      otherData: {
        totalContractAmount: 0,
        totalFundedAmount: 0,
        totalSignContractAmount: 0
      },
      quoteDialogOpenedQuoteId: null,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null,
        actualFundDate: [],
        contractNum: null,
        customerNum: null,
        customerName: null,
        contractTypeList: [],
        productTypeList: [],
        businessNum: null,
        businessName: null,
        contractStatusList: [],
        customerNatureList: [],
        signTime: [],
        deptIdList: [],
        managerIdList: []
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    AssignDialog,
    FollowAddDialog,
    PlanAddDialog,
    AddContractDialog,
    deptUserSelect,
  },
  created() {
    if (!this.$route.query.isAll) {
      this.queryParams.managerIdList = [this.currentUserId]
    }
    let workParams = this.$route.params // 工作台跳转进来
    if(Object.keys(workParams).length){
      this.autoSelectUser = false
      this.queryParams.signTime = workParams.signTime
      this.queryParams.actualFundDate = workParams.actualFundDate
      this.queryParams.deptIdList = workParams.deptIdList
      this.queryParams.managerIdList = workParams.managerIdList
    }else {
      this.autoSelectUser = true
    }
    this.getList();
    this.getDicts("contract_status").then(response => {
      this.statusOptions = response.data;
    });
    this.getDicts("sys_customer_type").then(response => {
      this.customerTypeOptions = response.data;
    });
    this.getDicts("customer_nature").then(response => {
      this.natureOptions = response.data;
    });
    this.getDicts("contract_type").then(response => {
      this.contractTypeOptions = response.data;
    });
    this.getDicts("product_type").then(response => {
      this.productTypeOptions = response.data;
    });
    listAllLevelArea({ level: 2 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
    this.openQuickCreateFromRoute()
    this.openQuoteContractFromRoute();
  },
  watch: {
    '$route.query.create'(){this.openQuickCreateFromRoute()},
    '$route.query.quoteId'() {
      this.openQuoteContractFromRoute();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      let params = this.dealQueryParam();
      pageContract(params).then(response => {
        const {code, rows, otherData, total, msg} = response
        if (code == 200) {
          this.dataList = rows || [];
          this.otherData = otherData || {}
          this.total = total;
        } else {
          this.$message.error(msg || '合同列表获取失败')
        }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.$message.error(error.msg || '合同列表获取失败')
      });
    },
    dealQueryParam() {
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.newestFund && params.newestFund.length > 1) {
        params.newestFundDateStart = params.newestFund[0]
        params.newestFundDateEnd = params.newestFund[1]
      }
      if (params.signTime && params.signTime.length > 1) {
        params.signTimeStart = params.signTime[0]
        params.signTimeEnd = params.signTime[1]
      }
      if (params.actualFundDate && params.actualFundDate.length > 1) {
        params.actualFundDateStart = params.actualFundDate[0]
        params.actualFundDateEnd = params.actualFundDate[1]
      }
      params.signTime = null
      params.actualFundDate = null
      params.provinceCode = params.area && params.area.length > 0 ? params.area[0] : null
      params.cityCode = params.area && params.area.length > 1 ? params.area[1] : null
      params.regionCode = params.area && params.area.length > 2 ? params.area[2] : null
      // 是否查询团队数据标志
      params.queryGroupFlag = true
      return params;
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.signTime = []
      this.queryParams.deptIdList = []
      this.queryParams.actualFundDate = []
      this.$refs.deptUserSelectRef.deptSelect()
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.multiple = !selection.length;
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/contract/detail/" + row.id, "_blank")
    },
    /** 详细按钮操作 */
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 详细按钮操作 */
    toBusinessDetail(row) {
      window.open("/crm/business/detail/" + row.businessId, "_blank")
    },
    /** 跟进按钮操作 */
    handleFollow(row) {
      this.$refs.followAddDialogRef.open("contract", row.id);
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$refs.addContractDialogRef.open();
    },
    openQuickCreateFromRoute(){
      if(this.$route.query.create!=='1')return
      this.$nextTick(()=>{this.handleAdd();const query={...this.$route.query};delete query.create;this.$router.replace({path:this.$route.path,query})})
    },
    openQuoteContractFromRoute() {
      const quoteId = this.$route.query.quoteId
      if (!quoteId || this.quoteDialogOpenedQuoteId === String(quoteId)) {
        return
      }
      this.quoteDialogOpenedQuoteId = String(quoteId)
      this.$nextTick(() => {
        if (this.$refs.addContractDialogRef) {
          this.$refs.addContractDialogRef.openFromQuote(quoteId)
        }
      })
    },
    handleContractSuccess() {
      this.getList()
      if (this.$route.query.quoteId) {
        const query = { ...this.$route.query }
        delete query.quoteId
        this.quoteDialogOpenedQuoteId = null
        this.$router.replace({ path: this.$route.path, query })
      }
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("contract", this.ids)
    },
    /** 计划按钮操作 */
    handlePlan(row) {
      this.$refs.planAddDialogRef.open("contract", row.id, row.assignUserId);
    },
    handleExport(){
      this.exportAmountUnit = 'TEN_THOUSAND'
      this.exportDialogVisible = true
    },
    confirmExport() {
      let params = this.dealQueryParam();
      params.pageNum = 1
      params.pageSize= 99999
      params.amountUnit = this.exportAmountUnit
      this.exportDialogVisible = false
      download.post("/crmContract/export", params)
    }
  }
};
</script>
<style lang="scss" scoped>
.totalCount {
  margin: 10px 0;
}

</style>
